import InventoryStore, { CreateInventoryItemParams } from 'admin/InventoryStore'
import { task } from 'mobx-task'
import Workspace from 'iam/models/Workspace'
import { BaseInventoryItemViewModel } from '../BaseInventoryItemDialog/BaseInventoryItemViewModel'
import { AlertFactory, AlertState } from 'alerts/Alert'
import { RefreshInventoryItems } from 'admin/inventory/InventorySearchViewModel'
import { SupportingItemsPorts } from '../../../ports'
import { override } from 'mobx'

export default class CreateInventoryItemViewModel extends BaseInventoryItemViewModel {
  constructor(
    private inventoryStore: InventoryStore,
    private refreshItems: RefreshInventoryItems,
    private newAlert: AlertFactory,
    supportingItemsAdapter: SupportingItemsPorts,
  ) {
    super(supportingItemsAdapter)
  }

  /**
   * Creates the inventory item
   */
  submit = task.resolved(async () => {
    if (!this.validate()) {
      return
    }

    const typeSpec = this.getInventoryItemTypeSpecification()

    const pricing = this.pricingViewModel.toValues()

    const payload: CreateInventoryItemParams = {
      name: this.name,
      description: this.description,
      courtesyAmount: this.courtesyQuantity,
      pricing,
      supportingItems: this.supportingItems,
      documentSignatureItems: this.documentSignatureItems,
      hideFromPro: this.hideFromPro,
      typeSpecification: typeSpec,
    }

    await this.inventoryStore
      .create(payload)
      .then(async () => {
        // Refresh the list to show new items
        await this.refreshItems(Workspace.none)

        this.newAlert()
          .withState(AlertState.Success)
          .saying('Success', 'Item added.')
          .autoDismiss()
          .show()

        this.reset()
        this.close()
      })
      .catch((e) => {
        this.newAlert()
          .withState(AlertState.Error)
          .saying('Error', e.message)
          .autoDismiss(2000)
          .show()
      })
  })

  @override
  open() {
    this.reset()
    this.show()
  }
}
